import React from 'react';
import { Card, CardContent, Typography, Box, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { VerifiedUser } from '@mui/icons-material';

interface Certification {
  certificationName?: string;
  name?: string;
  issuingOrganization?: string;
  issuing_organization?: string;
  issueDate?: string;
  issue_date?: string;
}

interface ProfileCertificationsProps {
  certifications?: Certification[];
}

export default function ProfileCertifications({ certifications }: ProfileCertificationsProps) {
  if (!certifications || certifications.length === 0) return null;

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Box display="flex" alignItems="center" mb={2}>
          <VerifiedUser sx={{ mr: 1 }} />
          <Typography variant="h6">Certifications</Typography>
        </Box>
        <List>
          {certifications.map((cert: Certification, index: number) => (
            <ListItem key={index}>
              <ListItemIcon>
                <VerifiedUser color="primary" />
              </ListItemIcon>
              <ListItemText
                primary={cert.certificationName || cert.name || 'Certification'}
                secondary={`${cert.issuingOrganization || cert.issuing_organization || ''} ${(cert.issueDate || cert.issue_date) ? `• ${cert.issueDate || cert.issue_date}` : ''}`}
              />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
}